/**
 * Every user-facing string, in English and Bangla. Keys are stable ids; the
 * Bangla table must cover every key (checked by a test).
 */
export const en = {
  // shell
  appName: 'Khata',
  nav_today: 'Today',
  nav_stock: 'Stock',
  nav_sales: 'Sales',
  nav_purchases: 'Purchases',
  nav_parties: 'Parties',
  nav_payments: 'Payments',
  nav_returns: 'Returns',
  nav_money: 'Drawings & expenses',
  nav_bank: 'Bank',
  nav_reports: 'Reports',
  nav_more: 'More',
  nav_settings: 'Settings',
  nav_books: 'Books',
  books_title: 'Books',
  books_sub: 'Trial balance and balance sheet as of today',
  books_balanceSheet: 'Balance sheet',
  books_trialBalance: 'Trial balance',
  books_assets: 'Assets',
  books_liabilities: 'Liabilities',
  books_equity: 'Equity',
  books_totalAssets: 'Total assets',
  books_totalLiabilities: 'Total liabilities',
  books_totalEquity: 'Total equity',
  books_liabilitiesPlusEquity: 'Liabilities + equity',
  books_balanced: 'Balanced',
  books_notBalanced: 'NOT balanced. Call the maintainer.',
  books_ledger: 'Ledger',
  books_debit: 'Debit',
  books_credit: 'Credit',
  books_total: 'Total',
  line_stock: 'Stock at cost',
  line_defective: 'Defective bin at cost',
  line_receivable: 'Receivable · {name}',
  line_vendor_advance: 'Advance to · {name}',
  line_payable: 'Payable · {name}',
  line_customer_advance: 'Advance from · {name}',
  line_overdraft: 'Overdraft · {name}',
  line_capital: 'Opening capital',
  line_profit: 'Profit to date',
  line_drawings: 'Drawings',
  tb_opening: 'Opening capital',
  tb_sales: 'Sales',
  tb_sales_returns: 'Sales returns',
  tb_cogs: 'Cost of goods sold',
  tb_expense: 'Expenses',
  tb_drawing: 'Drawings',
  tb_stock_adj: 'Stock adjustments',
  tb_stock: 'Stock',
  tb_defective: 'Defective bin',
  cf_title: 'Cash flow',
  cf_opening: 'Opening cash + bank',
  cf_in: 'Money in',
  cf_out: 'Money out',
  cf_salesCash: 'Cash sales',
  cf_customerPayments: 'Payments from customers',
  cf_vendorRefunds: 'Refunds from vendors',
  cf_openingBalances: 'Opening balances added',
  cf_purchasesCash: 'Cash purchases',
  cf_vendorPayments: 'Payments to vendors',
  cf_customerRefunds: 'Refunds to customers',
  cf_expenses: 'Expenses',
  cf_drawings: 'Drawings',
  cf_net: 'Net change',
  cf_closing: 'Closing cash + bank',
  cf_byAccount: 'By account',
  cf_account: 'Account',
  cf_in_short: 'In',
  cf_out_short: 'Out',
  ledger_title: 'Statement',
  ledger_balance: 'Balance',
  ledger_empty: 'No movements on this account yet.',
  ledger_missing: 'This account does not exist.',
  ledger_back: '← Bank',
  sync_offline: 'offline',
  sync_syncing: 'syncing…',
  sync_error: 'sync error',
  sync_synced: 'synced',
  banner_offline:
    'No connection to the server. You are seeing the last saved data; new entries cannot be saved until the connection is back.',
  banner_syncError: 'Could not sync with the server. Reload to try again.',
  opening: 'Opening khata…',
  errorScreen: 'Something went wrong on this screen',
  reload: 'Reload',
  language: 'Language',

  // common
  save: 'Save',
  saving: 'Saving…',
  close: 'Close',
  edit: 'Edit',
  date: 'Date',
  note: 'Note',
  optional: 'optional',
  amountTaka: 'Amount (৳)',
  quantity: 'Quantity',
  cash: 'Cash',
  bank: 'Bank',
  item: 'item',
  items: 'items',
  invoice: 'invoice',
  invoices: 'invoices',
  bill: 'bill',
  bills: 'bills',
  customer: 'Customer',
  customers: 'Customers',
  vendor: 'Vendor',
  vendors: 'Vendors',
  walkIn: 'Walk-in',
  noVendor: 'No vendor',
  bokeya: 'bokeya',
  due: 'due',
  paid: 'Paid',
  voided: 'voided',
  list_showVoided: 'Show voided',
  list_showMore: 'Show more · {shown} of {total}',
  period_thisMonth: 'This month',
  period_lastMonth: 'Last month',
  period_allTime: 'All time',
  period_pick: 'Month…',
  list_inPeriod: '{n} · {total} · {period}',
  list_search: 'Search…',
  picker_change: 'Change',
  picker_noMatch: 'No match.',
  picker_typeMore: '… and {n} more. Type to search.',
  picker_customer: 'Type customer name…',
  picker_vendor: 'Type vendor name…',
  picker_item: 'Type item name…',
  picker_account: 'Type account name…',
  search_tx: 'Search customer, item, memo no…',
  search_payments: 'Search party, note…',
  payments_period: 'Received {in} · paid {out}',
  search_money: 'Search purpose, note…',
  stock_filterAll: 'All',
  stock_filterLow: 'Low stock',
  stock_filterDead: 'Not selling',
  stock_deadSub: '{n} items · {value} tied up · no sale in {days} days',
  today_moreLow: '+{n} more',
  reports_dead: 'Dead stock · no sale in {days} days',
  reports_deadCount: 'Items not selling',
  reports_deadValue: 'Money tied up',
  reports_neverSold: 'Never sold',
  reports_lastSold: 'last sold {date}',
  reports_neverSoldShort: 'never sold',
  reports_seeInStock: 'See all in Stock',
  select: 'Select…',
  stock: 'Stock',
  defectiveBin: 'Defective bin',
  archived: 'archived',
  confirmDelete: 'Confirm delete',
  cannotChange: 'Cannot change',

  // login
  login_firstTime: 'first time setup',
  login_khata: 'khata',
  login_intro:
    'Name the shop, then create the first user: your name, a login (phone or email) and a PIN.',
  login_shopName: 'Shop name',
  login_shopPlaceholder: 'e.g. Rahim Motor Parts',
  login_choosePin: 'Choose a PIN (4 to 8 digits)',
  login_pin: 'PIN',
  login_create: 'Create khata',
  login_open: 'Open khata',
  login_wrong: 'Something went wrong.',
  login_id: 'Login (phone or email)',
  login_yourName: 'Your name',
  err_wrong_login: 'Wrong login or PIN.',
  err_forbidden: 'Only an owner can do that.',

  // today
  today_title: 'Today',
  today_sales: 'Sales today',
  today_cash: 'Cash in hand',
  today_bank: 'Bank & mobile',
  today_recv: 'Customers owe (bokeya)',
  today_pay: 'We owe vendors',
  today_newSale: '＋ New sale',
  today_newPurchase: 'New purchase',
  today_receive: 'Receive payment',
  today_pay_btn: 'Pay vendor',
  today_low: 'Low stock',
  today_recent: 'Recent activity',
  today_empty: 'Nothing recorded yet. Start with a purchase or an opening stock count.',
  customerOne: 'customer',
  customerMany: 'customers',
  vendorOne: 'vendor',
  vendorMany: 'vendors',

  // stock
  stock_title: 'Stock',
  stock_sub: '{n} · value {value} at cost',
  stock_add: '＋ Item',
  stock_search: 'Search name, category, origin…',
  stock_all: 'All',
  stock_empty: 'No items yet. Add your first item.',
  stock_noMatch: 'Nothing matches.',
  stock_buy: 'buy',
  stock_sell: 'sell',
  stock_defective: 'defective',
  stock_out: 'Out of stock',
  stock_low: 'Low',

  // sales / purchases
  tx_sales: 'Sales',
  tx_purchases: 'Purchases',
  tx_thisMonth: '{n} this month · {total}',
  tx_new: '＋ New',
  tx_noSales: 'No sales yet.',
  tx_noPurchases: 'No purchases yet.',
  tx_paidVia: 'Paid · {account}',
  tx_total: '{n} in total.',
  saleOne: 'sale',
  saleMany: 'sales',
  purchaseOne: 'purchase',
  purchaseMany: 'purchases',

  // parties
  parties_title: 'Parties',
  parties_sub: '{n} customers owe {recv} · you owe {pay}',
  parties_add: '＋ Party',
  parties_empty: 'No {type} yet.',
  parties_last: 'last {date}',
  parties_noActivity: 'no activity',
  parties_owesYou: 'owes you',
  parties_youOwe: 'you owe',
  parties_advance: 'advance',
  parties_settled: 'settled',
  party_back: '← Parties',
  party_missing: 'This party does not exist.',
  party_owesYou: 'Owes you (bokeya)',
  party_youOwe: 'You owe',
  party_advanceHeld: 'Advance held',
  party_settled: 'Settled',
  party_receive: 'Receive payment',
  party_pay: 'Pay vendor',
  party_newSale: 'New sale',
  party_newPurchase: 'New purchase',
  party_ledger: 'Ledger',
  party_noEntries: 'No entries with {name} yet.',
  party_paymentReceived: 'Payment received',
  party_paymentMade: 'Payment made',
  party_openingBalance: 'Opening balance',
  party_total: 'total',
  party_paid: 'paid',
  party_bal: 'bal',

  // payments
  payments_title: 'Payments',
  payments_sub: 'Received {in} · paid {out} this month',
  payments_receive: 'Receive',
  payments_pay: 'Pay',
  payments_empty: 'No payments yet.',
  payments_from: 'From',
  payments_to: 'To',

  // returns
  returns_title: 'Returns & defects',
  returns_sub: '{n} defective pieces in the bin',
  returns_add: '＋ Return',
  returns_empty: 'No returns recorded.',
  returns_fromCustomer: 'from',
  returns_toVendor: 'to',
  returns_binHint: 'Send back to vendor or write off',

  // money
  money_title: 'Drawings & expenses',
  money_sub: 'This month · drawings {draw} · expenses {exp}',
  money_expense: 'Expense',
  money_drawing: 'Drawing',
  money_empty: 'Nothing recorded yet.',

  // bank
  bank_title: 'Bank',
  bank_sub: 'Cash in hand {cash} · bank & mobile {bank}',
  bank_transfer: '＋ Transfer',
  bank_account: '＋ Account',
  bank_movements: 'Bank movements',
  bank_empty: 'No deposits, withdrawals or transfers yet.',
  bank_closed: 'closed',
  bank_kindCash: 'cash',
  bank_kindBank: 'bank',
  bank_kindMobile: 'mobile wallet',
  bank_groupCash: 'Cash',
  bank_groupBank: 'Bank accounts',
  bank_groupMobile: 'Mobile wallets',

  // reports
  reports_title: 'Reports',
  reports_thisMonth: 'This month',
  reports_lastMonth: 'Last month',
  reports_allTime: 'All time',
  reports_sales: 'Sales',
  reports_cogs: 'Cost of goods',
  reports_gross: 'Gross profit',
  reports_margin: '{pct}% margin',
  reports_expenses: 'Expenses',
  reports_net: 'Net profit',
  reports_afterExpenses: 'after expenses',
  reports_purchases: 'Purchases',
  reports_drawings: 'Owner drawings',
  reports_returns: 'Returns',
  reports_stockAdj: 'Stock loss / gain',
  reports_loss: 'loss',
  reports_gain: 'gain',
  reports_chart: 'Sales · last 6 months',
  reports_position: 'Position today',
  reports_stockAtCost: 'Stock at cost',
  reports_defectiveAtCost: 'Defective bin at cost',
  reports_cash: 'Cash in hand',
  reports_bank: 'Bank & mobile balances',
  reports_receivable: 'Receivable from customers',
  reports_payable: 'Payable to vendors',
  reports_advances: 'Advances held / paid',
  reports_netWorth: 'Net worth',
  reports_top: 'Top items · {period}',
  reports_noSales: 'No sales in this period.',
  period_this: 'this month',
  period_last: 'last month',
  period_all: 'all time',

  // more / settings
  more_title: 'More',
  settings_title: 'Settings',
  settings_sub: '{n} entries · app {version}',
  settings_shopName: 'Shop name',
  settings_saveName: 'Save name',
  settings_nameSaved: 'Shop name saved',
  settings_changePin: 'Change PIN',
  settings_currentPin: 'Current PIN',
  settings_newPin: 'New PIN (4 to 8 digits)',
  settings_pinChanged: 'PIN changed',
  settings_pinFailed: 'Could not change the PIN.',
  settings_saveFailed: 'Could not save.',
  settings_backup: 'Backup',
  settings_backupHelp:
    'Downloads the whole khata as one JSON file: {n} entries plus items, parties and accounts.',
  settings_download: 'Download backup',
  settings_device: 'This device',
  settings_logout: 'Log out',
  settings_language: 'Language',
  settings_you: 'You',
  settings_youTag: 'you',
  settings_users: 'Users',
  settings_addUser: '＋ User',

  // sheets: sale / purchase
  sheet_newSale: 'New sale',
  sheet_newPurchase: 'New purchase',
  sheet_walkIn: 'Walk-in customer (cash)',
  sheet_cashPurchase: 'Cash purchase (no vendor)',
  sheet_addItem: 'Add item',
  sheet_searchItems: 'Type to search items…',
  sheet_noItemMatch: 'No item matches. Add it under Stock first.',
  sheet_left: 'left',
  sheet_qty: 'Qty',
  sheet_price: 'Price',
  sheet_cost: 'Cost',
  sheet_remove: 'Remove',
  sheet_total: 'Total',
  sheet_paidNow: 'Paid now',
  sheet_inFull: 'in full',
  sheet_into: 'Into',
  sheet_from: 'From',
  sheet_remaining: 'Remaining',
  sheet_saveSale: 'Save sale',
  sheet_savePurchase: 'Save purchase',
  sheet_saleSaved: 'Sale #{no} saved · {total}',
  sheet_purchaseSaved: 'Purchase #{no} saved · {total}',
  sheet_addOne: 'Add at least one item.',

  // sheets: item
  sheet_editItem: 'Edit item',
  sheet_newItem: 'New item',
  item_name: 'Name',
  item_namePlaceholder: 'e.g. Headlight bulb H4',
  item_needsName: 'Item needs a name.',
  item_category: 'Category',
  item_categoryDefault: 'Other',
  item_origin: 'Origin',
  item_unit: 'Unit',
  item_lowAlert: 'Low alert at',
  item_lowInvalid: 'Low alert must be a quantity.',
  item_sellPrice: 'Sell price (৳)',
  item_sellInvalid: 'Sell price must be an amount.',
  item_inStock: 'In stock',
  item_avgCost: 'avg cost',
  item_adjust: 'Adjust stock',
  item_delete: 'Delete item',
  item_deleteHelp:
    'If this item appears in any entry it is archived instead of deleted, so old sales still make sense.',
  item_openingHead: 'Opening stock (optional)',
  item_buyPrice: 'Buy price (৳)',
  item_buyRequired: 'Enter the buy price for the opening stock.',
  item_asOf: 'As of',
  item_saved: '{name} saved',
  item_added: '{name} added',
  item_deleted: 'Item deleted',
  item_archived: '{name} archived (it has entries, so it stays in the history)',
  item_restore: 'Restore archived item',
  item_restored: 'Item restored',

  // sheets: party
  sheet_editParty: 'Edit party',
  sheet_newParty: 'New party',
  party_needsName: 'Party needs a name.',
  party_type: 'Type',
  party_phone: 'Phone',
  party_address: 'Address / note',
  party_openingHead: 'Opening balance (optional)',
  party_whichWay: 'Which way',
  party_theyOwe: 'They owe you',
  party_youOweThem: 'You owe them',
  party_advanceFrom: 'Advance from them',
  party_advanceTo: 'Advance paid to them',
  party_saved: '{name} saved',
  party_added: '{name} added',
  party_delete: 'Delete party',
  party_deleteHelp: 'A party with entries is archived, not deleted.',
  party_deleted: 'Party deleted',
  party_archived: '{name} archived',

  // sheets: payment
  sheet_receivePayment: 'Receive payment',
  sheet_payVendor: 'Pay vendor',
  payment_choose: 'Choose a party.',
  payment_via: 'Via',
  payment_notePlaceholder: 'cheque no, bKash…',
  payment_received: 'Received {amount}',
  payment_paid: 'Paid {amount}',
  payment_dueSuffix: 'due {amount}',
  payment_advanceSuffix: 'advance {amount}',

  // sheets: return
  sheet_return: 'Record return',
  return_type: 'Type',
  return_customerReturned: 'Customer returned to us',
  return_weReturn: 'We return to vendor',
  return_walkIn: 'Walk-in (cash refund out)',
  return_noVendor: 'No vendor (cash refund in)',
  return_item: 'Item',
  return_chooseItem: 'Choose an item.',
  return_inStock: 'in stock',
  return_defectiveCount: 'defective',
  return_auto: 'auto {amount}',
  return_autoFromPrice: 'auto from price',
  return_reason: 'Reason',
  return_goesTo: 'Goes to',
  return_takeFrom: 'Take from',
  return_refundVia: 'Refund via',
  return_refundViaIfCash: 'Refund via (if cash)',
  return_help_saleDefective:
    'Goes to the defective bin, not back into stock. The amount is credited to the customer (or refunded in cash for a walk-in).',
  return_help_saleStock:
    'Goes back into stock. The amount is credited to the customer (or refunded in cash for a walk-in).',
  return_help_purchaseDefective:
    'Taken out of the defective bin. The amount reduces what you owe the vendor (or comes back as cash).',
  return_help_purchaseStock:
    'Stock goes down. The amount reduces what you owe the vendor (or comes back as cash).',
  return_recorded: 'Return recorded · {amount}',
  reason_defective: 'Defective',
  reason_wrong_item: 'Wrong item',
  reason_not_needed: 'Not needed',
  reason_damaged: 'Damaged in transit',

  // sheets: money
  sheet_expense: 'Expense',
  sheet_drawing: 'Owner / staff drawing',
  money_whatFor: 'What for',
  money_who: 'Who',
  money_forPlaceholder: 'Rent, electricity, salary…',
  money_whoPlaceholder: 'Owner, staff name…',
  money_whatForMissing: 'What was it for?',
  money_whoMissing: 'Who is drawing?',
  money_owner: 'Owner',
  money_expenseSaved: 'Expense saved · {amount}',
  money_drawingSaved: 'Drawing saved · {amount}',

  // sheets: transfer
  sheet_bankMovement: 'Bank movement',
  transfer_type: 'Type',
  transfer_deposit: 'Deposit cash → bank',
  transfer_withdraw: 'Withdraw bank → cash',
  transfer_transfer: 'Bank → bank transfer',
  transfer_cashAccount: 'Cash account',
  transfer_fromAccount: 'From account',
  transfer_toAccount: 'To account',
  transfer_noteRef: 'Note / ref',
  transfer_noBank: 'No bank or mobile wallet yet. Add one from the Bank screen.',
  transfer_addFirst: 'Add a bank or mobile wallet first.',
  transfer_saved: 'Bank movement saved',

  // sheets: account
  sheet_editAccount: 'Edit account',
  sheet_newAccount: 'New account',
  sheet_newUser: 'New user',
  sheet_editUser: 'Edit user',
  user_name: 'Name',
  user_namePlaceholder: 'e.g. Rahim',
  user_login: 'Login (phone or email)',
  user_loginPlaceholder: '01711-000000 or name@example.com',
  user_pin: 'PIN (4 to 8 digits)',
  user_newPin: 'New PIN',
  user_keepPin: 'leave empty to keep',
  user_active: 'Active',
  user_disabled: 'Disabled',
  user_help: 'Each person logs in with their own login and PIN; every entry records who wrote it.',
  user_needsName: 'Name is required.',
  user_needsPin: 'PIN must be 4 to 8 digits.',
  user_added: '{name} added',
  user_saved: '{name} saved',
  account_namePlaceholder: 'e.g. DBBL Current, bKash Merchant',
  account_needsName: 'Account needs a name.',
  account_kind: 'Kind',
  account_kindBank: 'Bank',
  account_kindMobile: 'Mobile wallet (bKash, Nagad, Rocket…)',
  account_kindCash: 'Cash box',
  account_status: 'Status',
  account_open: 'Open',
  account_closed: 'Closed',
  account_opening: 'Opening balance (৳)',
  account_saved: '{name} saved',
  account_added: '{name} added',

  // sheets: adjust
  sheet_adjust: 'Adjust · {name}',
  adjust_now: 'Now: {qty} {unit} in stock at avg {cost}',
  adjust_inBin: 'in the defective bin',
  adjust_where: 'Where',
  adjust_direction: 'Direction',
  adjust_add: 'Add pieces',
  adjust_remove: 'Remove pieces',
  adjust_unitCost: 'Unit cost (৳)',
  adjust_unitCostRequired: 'Enter the unit cost of the pieces being added.',
  adjust_goesOutAt: 'Goes out at',
  adjust_avgCost: 'avg cost',
  adjust_reason: 'Reason',
  adjust_saved: '{name} adjusted',
  adjustReason_opening: 'Opening stock',
  adjustReason_count: 'Count correction',
  adjustReason_damage: 'Damage write-off',
  adjustReason_other: 'Other',

  // sheets: entry detail
  entry_notFound: 'Not found.',
  entry_by: 'Recorded by',
  entry_unknownUser: 'unknown',
  entry_voidedBanner: 'Voided{when}. It no longer counts anywhere.',
  entry_on: ' on {date}',
  entry_void: 'Void this entry',
  entry_voidHelp:
    'Voiding reverses this entry exactly and keeps it in the history. Stock, cash and balances go back to what they were.',
  entry_voidReason: 'Reason (optional)',
  entry_voidReasonPlaceholder: 'e.g. wrong quantity',
  entry_confirmVoid: 'Confirm void',
  entry_voiding: 'Voiding…',
  entry_keep: 'Keep it',
  entry_voidedToast: '{title} voided',
  entry_printMemo: 'Print memo',
  entry_total: 'Total',
  entry_paid: 'Paid',
  entry_bokeya: 'Bokeya',
  entry_stillOwed: 'Still owed',
  entry_amount: 'Amount',
  entry_via: 'Via',
  entry_kind: 'Kind',
  entry_party: 'Party',
  entry_item: 'Item',
  entry_reason: 'Reason',
  entry_wentTo: 'Went to',
  entry_takenFrom: 'Taken from',
  entry_refundVia: 'Refund via',
  entry_for: 'For',
  entry_who: 'Who',
  entry_from: 'From',
  entry_to: 'To',
  entry_change: 'Change',
  entry_in: 'in',
  entry_unitCost: 'Unit cost',
  entry_account: 'Account',
  entry_openingBalance: 'Opening balance',
  entry_voidedEntry: 'Voided entry',
  entry_note: 'Note',
  type_sale: 'Sale',
  type_purchase: 'Purchase',
  type_payment: 'Payment',
  type_return: 'Return',
  type_expense: 'Expense',
  type_drawing: 'Drawing',
  type_transfer: 'Bank movement',
  type_stock_adjust: 'Stock adjustment',
  type_account_opening: 'Account opening',
  type_party_opening: 'Party opening',
  type_void: 'Void',

  // labels (lists)
  label_receivedFrom: 'Received from',
  label_paidTo: 'Paid to',
  label_deposit: 'Deposit → {to}',
  label_withdraw: 'Withdraw from {from}',
  label_openingBalance: 'Opening balance',
  label_deletedParty: '(deleted party)',
  label_deletedItem: '(deleted item)',
  label_closedAccount: '(closed account)',
  label_perUnit: '/unit',

  // memo
  memo_missing: 'This memo does not exist.',
  memo_back: '← Back',
  memo_print: 'Print',
  memo_memo: 'Memo',
  memo_customer: 'Customer:',
  memo_item: 'Item',
  memo_qty: 'Qty',
  memo_price: 'Price',
  memo_amount: 'Amount',
  memo_total: 'Total',
  memo_paid: 'Paid',
  memo_due: 'Due on this memo',
  memo_previous: 'Previous balance',
  memo_balanceNow: 'Balance now',
  memo_note: 'Note:',
  memo_thanks: 'Thank you · Goods once sold are returned only as per shop policy.',

  // form validation
  form_enterAmount: 'Enter an amount.',
  form_invalidAmount: 'Enter a valid amount, like 1250 or 99.50.',
  form_negativeAmount: 'Amount cannot be negative.',
  form_enterQty: 'Enter a quantity.',
  form_invalidQty: 'Enter a valid quantity, like 2 or 1.5.',
  form_offline: 'No connection. The entry was not saved.',
  form_failed: 'Something went wrong. The entry was not saved.',

  // server / core error codes (re-phrased; params come with the error)
  err_must_be_fully_paid: 'Walk-in sale must be fully paid. Choose a customer to record bokeya.',
  err_must_be_fully_paid_purchase:
    'Cash purchase must be fully paid. Choose a vendor to record what you owe.',
  err_paid_exceeds_total: 'Paid is more than the total. Record the extra as a payment.',
  err_insufficient_stock: 'Only {availableText} {unit} of {item} {where}.',
  err_insufficient_stock_none: '{item} has nothing {where}.',
  err_where_stock: 'in stock',
  err_where_defective: 'in the defective bin',
  err_conflict: 'Another device saved first. Please try again.',
  err_void_blocked:
    'Cannot void: the {item} it added has since been sold, returned or adjusted. Void those later entries first.',
  err_already_voided: 'That entry is already voided.',
  err_wrong_pin: 'Wrong PIN.',
  err_locked: 'Too many wrong PINs. Try again in a minute.',
  err_same_account: 'Pick two different accounts.',
  err_duplicate_item: '{item} is on the list twice.',
} as const;

export type StringKey = keyof typeof en;

export const bn: Record<StringKey, string> = {
  appName: 'খাতা',
  nav_today: 'আজ',
  nav_stock: 'স্টক',
  nav_sales: 'বিক্রি',
  nav_purchases: 'ক্রয়',
  nav_parties: 'পার্টি',
  nav_payments: 'পেমেন্ট',
  nav_returns: 'ফেরত',
  nav_money: 'খরচ ও উত্তোলন',
  nav_bank: 'ব্যাংক',
  nav_reports: 'রিপোর্ট',
  nav_more: 'আরও',
  nav_settings: 'সেটিংস',
  nav_books: 'হিসাবের খাতা',
  books_title: 'হিসাবের খাতা',
  books_sub: 'আজকের ট্রায়াল ব্যালেন্স আর ব্যালেন্স শিট',
  books_balanceSheet: 'ব্যালেন্স শিট',
  books_trialBalance: 'ট্রায়াল ব্যালেন্স',
  books_assets: 'সম্পদ',
  books_liabilities: 'দায়',
  books_equity: 'মূলধন',
  books_totalAssets: 'মোট সম্পদ',
  books_totalLiabilities: 'মোট দায়',
  books_totalEquity: 'মোট মূলধন',
  books_liabilitiesPlusEquity: 'দায় + মূলধন',
  books_balanced: 'মিলেছে',
  books_notBalanced: 'মেলেনি। মেইনটেইনারকে জানান।',
  books_ledger: 'খাত',
  books_debit: 'ডেবিট',
  books_credit: 'ক্রেডিট',
  books_total: 'মোট',
  line_stock: 'স্টক (ক্রয়মূল্যে)',
  line_defective: 'নষ্ট মাল (ক্রয়মূল্যে)',
  line_receivable: 'পাওনা · {name}',
  line_vendor_advance: 'অগ্রিম দেওয়া · {name}',
  line_payable: 'দেনা · {name}',
  line_customer_advance: 'অগ্রিম নেওয়া · {name}',
  line_overdraft: 'ওভারড্রাফট · {name}',
  line_capital: 'শুরুর মূলধন',
  line_profit: 'এ পর্যন্ত লাভ',
  line_drawings: 'উত্তোলন',
  tb_opening: 'শুরুর মূলধন',
  tb_sales: 'বিক্রি',
  tb_sales_returns: 'বিক্রি ফেরত',
  tb_cogs: 'বিক্রিত মালের খরচ',
  tb_expense: 'খরচ',
  tb_drawing: 'উত্তোলন',
  tb_stock_adj: 'স্টক সংশোধন',
  tb_stock: 'স্টক',
  tb_defective: 'নষ্ট মালের বিন',
  cf_title: 'নগদ প্রবাহ',
  cf_opening: 'শুরুতে নগদ + ব্যাংক',
  cf_in: 'টাকা এসেছে',
  cf_out: 'টাকা গেছে',
  cf_salesCash: 'নগদ বিক্রি',
  cf_customerPayments: 'কাস্টমারের পেমেন্ট',
  cf_vendorRefunds: 'সাপ্লায়ার থেকে ফেরত',
  cf_openingBalances: 'শুরুর ব্যালেন্স যোগ',
  cf_purchasesCash: 'নগদ ক্রয়',
  cf_vendorPayments: 'সাপ্লায়ারকে পেমেন্ট',
  cf_customerRefunds: 'কাস্টমারকে ফেরত',
  cf_expenses: 'খরচ',
  cf_drawings: 'উত্তোলন',
  cf_net: 'নিট পরিবর্তন',
  cf_closing: 'শেষে নগদ + ব্যাংক',
  cf_byAccount: 'অ্যাকাউন্ট অনুযায়ী',
  cf_account: 'অ্যাকাউন্ট',
  cf_in_short: 'এসেছে',
  cf_out_short: 'গেছে',
  ledger_title: 'স্টেটমেন্ট',
  ledger_balance: 'ব্যালেন্স',
  ledger_empty: 'এই অ্যাকাউন্টে এখনো কোনো লেনদেন নেই।',
  ledger_missing: 'এই অ্যাকাউন্ট নেই।',
  ledger_back: '← ব্যাংক',
  sync_offline: 'অফলাইন',
  sync_syncing: 'সিংক হচ্ছে…',
  sync_error: 'সিংক সমস্যা',
  sync_synced: 'সিংক হয়েছে',
  banner_offline:
    'সার্ভারের সাথে সংযোগ নেই। শেষ সেভ করা তথ্য দেখছেন; সংযোগ ফিরে না আসা পর্যন্ত নতুন এন্ট্রি সেভ হবে না।',
  banner_syncError: 'সার্ভারের সাথে সিংক করা যায়নি। আবার চেষ্টা করতে রিলোড করুন।',
  opening: 'খাতা খুলছে…',
  errorScreen: 'এই স্ক্রিনে একটা সমস্যা হয়েছে',
  reload: 'রিলোড',
  language: 'ভাষা',

  save: 'সেভ করুন',
  saving: 'সেভ হচ্ছে…',
  close: 'বন্ধ',
  edit: 'এডিট',
  date: 'তারিখ',
  note: 'নোট',
  optional: 'ঐচ্ছিক',
  amountTaka: 'টাকা (৳)',
  quantity: 'পরিমাণ',
  cash: 'নগদ',
  bank: 'ব্যাংক',
  item: 'আইটেম',
  items: 'আইটেম',
  invoice: 'মেমো',
  invoices: 'মেমো',
  bill: 'বিল',
  bills: 'বিল',
  customer: 'কাস্টমার',
  customers: 'কাস্টমার',
  vendor: 'সাপ্লায়ার',
  vendors: 'সাপ্লায়ার',
  walkIn: 'খুচরা',
  noVendor: 'সাপ্লায়ার নেই',
  bokeya: 'বাকি',
  due: 'বাকি',
  paid: 'পরিশোধ',
  voided: 'বাতিল',
  list_showVoided: 'বাতিল দেখান',
  list_showMore: 'আরও দেখান · {total}-এর {shown}টি',
  period_thisMonth: 'এই মাস',
  period_lastMonth: 'গত মাস',
  period_allTime: 'সব সময়',
  period_pick: 'মাস…',
  list_inPeriod: '{n} · {total} · {period}',
  list_search: 'খুঁজুন…',
  picker_change: 'বদলান',
  picker_noMatch: 'মেলেনি।',
  picker_typeMore: '… আরও {n}টি। খুঁজতে লিখুন।',
  picker_customer: 'কাস্টমারের নাম লিখুন…',
  picker_vendor: 'সাপ্লায়ারের নাম লিখুন…',
  picker_item: 'আইটেমের নাম লিখুন…',
  picker_account: 'অ্যাকাউন্টের নাম লিখুন…',
  search_tx: 'কাস্টমার, আইটেম, মেমো নং খুঁজুন…',
  search_payments: 'পার্টি, নোট খুঁজুন…',
  payments_period: 'পেয়েছেন {in} · দিয়েছেন {out}',
  search_money: 'কী বাবদ, নোট খুঁজুন…',
  stock_filterAll: 'সব',
  stock_filterLow: 'স্টক কম',
  stock_filterDead: 'বিক্রি হয় না',
  stock_deadSub: '{n} আইটেম · {value} আটকে আছে · {days} দিন বিক্রি নেই',
  today_moreLow: '+{n} আরও',
  reports_dead: 'অচল স্টক · {days} দিন বিক্রি নেই',
  reports_deadCount: 'বিক্রি হচ্ছে না এমন আইটেম',
  reports_deadValue: 'আটকে থাকা টাকা',
  reports_neverSold: 'কখনো বিক্রি হয়নি',
  reports_lastSold: 'শেষ বিক্রি {date}',
  reports_neverSoldShort: 'কখনো বিক্রি হয়নি',
  reports_seeInStock: 'স্টকে সব দেখুন',
  select: 'বেছে নিন…',
  stock: 'স্টক',
  defectiveBin: 'নষ্ট মালের বিন',
  archived: 'আর্কাইভ',
  confirmDelete: 'মুছে ফেলা নিশ্চিত করুন',
  cannotChange: 'বদলানো যাবে না',

  login_firstTime: 'প্রথমবার সেটআপ',
  login_khata: 'খাতা',
  login_intro:
    'দোকানের নাম দিন, তারপর প্রথম ইউজার বানান: আপনার নাম, লগইন (ফোন বা ইমেইল) আর একটা পিন।',
  login_shopName: 'দোকানের নাম',
  login_shopPlaceholder: 'যেমন: রহিম মোটর পার্টস',
  login_choosePin: 'পিন বেছে নিন (৪ থেকে ৮ সংখ্যা)',
  login_pin: 'পিন',
  login_create: 'খাতা তৈরি করুন',
  login_open: 'খাতা খুলুন',
  login_wrong: 'কিছু একটা সমস্যা হয়েছে।',
  login_id: 'লগইন (ফোন বা ইমেইল)',
  login_yourName: 'আপনার নাম',
  err_wrong_login: 'লগইন বা পিন ভুল।',
  err_forbidden: 'শুধু মালিক এটা করতে পারেন।',

  today_title: 'আজ',
  today_sales: 'আজকের বিক্রি',
  today_cash: 'হাতে নগদ',
  today_bank: 'ব্যাংক ও মোবাইল',
  today_recv: 'কাস্টমারের বাকি',
  today_pay: 'সাপ্লায়ারের পাওনা',
  today_newSale: '＋ নতুন বিক্রি',
  today_newPurchase: 'নতুন ক্রয়',
  today_receive: 'টাকা নিন',
  today_pay_btn: 'সাপ্লায়ারকে দিন',
  today_low: 'স্টক কম',
  today_recent: 'সাম্প্রতিক লেনদেন',
  today_empty: 'এখনো কিছু লেখা হয়নি। একটা ক্রয় বা শুরুর স্টক দিয়ে শুরু করুন।',
  customerOne: 'জন কাস্টমার',
  customerMany: 'জন কাস্টমার',
  vendorOne: 'জন সাপ্লায়ার',
  vendorMany: 'জন সাপ্লায়ার',

  stock_title: 'স্টক',
  stock_sub: '{n} · ক্রয়মূল্যে {value}',
  stock_add: '＋ আইটেম',
  stock_search: 'নাম, ক্যাটাগরি, উৎস খুঁজুন…',
  stock_all: 'সব',
  stock_empty: 'এখনো কোনো আইটেম নেই। প্রথম আইটেম যোগ করুন।',
  stock_noMatch: 'কিছু মেলেনি।',
  stock_buy: 'ক্রয়',
  stock_sell: 'বিক্রয়',
  stock_defective: 'নষ্ট',
  stock_out: 'স্টক শেষ',
  stock_low: 'কম',

  tx_sales: 'বিক্রি',
  tx_purchases: 'ক্রয়',
  tx_thisMonth: 'এই মাসে {n} · {total}',
  tx_new: '＋ নতুন',
  tx_noSales: 'এখনো কোনো বিক্রি নেই।',
  tx_noPurchases: 'এখনো কোনো ক্রয় নেই।',
  tx_paidVia: 'পরিশোধ · {account}',
  tx_total: 'মোট {n}।',
  saleOne: 'টি বিক্রি',
  saleMany: 'টি বিক্রি',
  purchaseOne: 'টি ক্রয়',
  purchaseMany: 'টি ক্রয়',

  parties_title: 'পার্টি',
  parties_sub: '{n} জন কাস্টমারের বাকি {recv} · আপনার দেনা {pay}',
  parties_add: '＋ পার্টি',
  parties_empty: 'এখনো কোনো {type} নেই।',
  parties_last: 'শেষ {date}',
  parties_noActivity: 'কোনো লেনদেন নেই',
  parties_owesYou: 'আপনার পাওনা',
  parties_youOwe: 'আপনি দেবেন',
  parties_advance: 'অগ্রিম',
  parties_settled: 'হিসাব মিটেছে',
  party_back: '← পার্টি',
  party_missing: 'এই পার্টি নেই।',
  party_owesYou: 'আপনার পাওনা (বাকি)',
  party_youOwe: 'আপনি দেবেন',
  party_advanceHeld: 'অগ্রিম জমা আছে',
  party_settled: 'হিসাব মিটেছে',
  party_receive: 'টাকা নিন',
  party_pay: 'সাপ্লায়ারকে দিন',
  party_newSale: 'নতুন বিক্রি',
  party_newPurchase: 'নতুন ক্রয়',
  party_ledger: 'খতিয়ান',
  party_noEntries: '{name}-এর সাথে এখনো কোনো লেনদেন নেই।',
  party_paymentReceived: 'টাকা পাওয়া গেছে',
  party_paymentMade: 'টাকা দেওয়া হয়েছে',
  party_openingBalance: 'শুরুর ব্যালেন্স',
  party_total: 'মোট',
  party_paid: 'পরিশোধ',
  party_bal: 'ব্যাল.',

  payments_title: 'পেমেন্ট',
  payments_sub: 'এই মাসে পেয়েছেন {in} · দিয়েছেন {out}',
  payments_receive: 'নিন',
  payments_pay: 'দিন',
  payments_empty: 'এখনো কোনো পেমেন্ট নেই।',
  payments_from: 'থেকে:',
  payments_to: 'কে:',

  returns_title: 'ফেরত ও নষ্ট মাল',
  returns_sub: 'বিনে {n} পিস নষ্ট মাল',
  returns_add: '＋ ফেরত',
  returns_empty: 'কোনো ফেরত লেখা হয়নি।',
  returns_fromCustomer: 'ফেরত দিয়েছে',
  returns_toVendor: 'ফেরত পাঠানো',
  returns_binHint: 'সাপ্লায়ারকে ফেরত দিন বা বাদ দিন',

  money_title: 'খরচ ও উত্তোলন',
  money_sub: 'এই মাসে · উত্তোলন {draw} · খরচ {exp}',
  money_expense: 'খরচ',
  money_drawing: 'উত্তোলন',
  money_empty: 'এখনো কিছু লেখা হয়নি।',

  bank_title: 'ব্যাংক',
  bank_sub: 'হাতে নগদ {cash} · ব্যাংক ও মোবাইল {bank}',
  bank_transfer: '＋ লেনদেন',
  bank_account: '＋ অ্যাকাউন্ট',
  bank_movements: 'ব্যাংক লেনদেন',
  bank_empty: 'এখনো কোনো জমা, তোলা বা ট্রান্সফার নেই।',
  bank_closed: 'বন্ধ',
  bank_kindCash: 'নগদ',
  bank_kindBank: 'ব্যাংক',
  bank_kindMobile: 'মোবাইল ব্যাংকিং',
  bank_groupCash: 'নগদ',
  bank_groupBank: 'ব্যাংক অ্যাকাউন্ট',
  bank_groupMobile: 'মোবাইল ব্যাংকিং',

  reports_title: 'রিপোর্ট',
  reports_thisMonth: 'এই মাস',
  reports_lastMonth: 'গত মাস',
  reports_allTime: 'সব সময়',
  reports_sales: 'বিক্রি',
  reports_cogs: 'বিক্রিত মালের খরচ',
  reports_gross: 'মোট লাভ',
  reports_margin: '{pct}% মার্জিন',
  reports_expenses: 'খরচ',
  reports_net: 'নিট লাভ',
  reports_afterExpenses: 'খরচ বাদে',
  reports_purchases: 'ক্রয়',
  reports_drawings: 'মালিকের উত্তোলন',
  reports_returns: 'ফেরত',
  reports_stockAdj: 'স্টক ক্ষতি / লাভ',
  reports_loss: 'ক্ষতি',
  reports_gain: 'লাভ',
  reports_chart: 'বিক্রি · শেষ ৬ মাস',
  reports_position: 'আজকের অবস্থা',
  reports_stockAtCost: 'স্টক (ক্রয়মূল্যে)',
  reports_defectiveAtCost: 'নষ্ট মাল (ক্রয়মূল্যে)',
  reports_cash: 'হাতে নগদ',
  reports_bank: 'ব্যাংক ও মোবাইল ব্যালেন্স',
  reports_receivable: 'কাস্টমারের কাছে পাওনা',
  reports_payable: 'সাপ্লায়ারকে দেনা',
  reports_advances: 'অগ্রিম নেওয়া / দেওয়া',
  reports_netWorth: 'নিট সম্পদ',
  reports_top: 'সেরা আইটেম · {period}',
  reports_noSales: 'এই সময়ে কোনো বিক্রি নেই।',
  period_this: 'এই মাস',
  period_last: 'গত মাস',
  period_all: 'সব সময়',

  more_title: 'আরও',
  settings_title: 'সেটিংস',
  settings_sub: '{n} এন্ট্রি · অ্যাপ {version}',
  settings_shopName: 'দোকানের নাম',
  settings_saveName: 'নাম সেভ করুন',
  settings_nameSaved: 'দোকানের নাম সেভ হয়েছে',
  settings_changePin: 'পিন বদলান',
  settings_currentPin: 'বর্তমান পিন',
  settings_newPin: 'নতুন পিন (৪ থেকে ৮ সংখ্যা)',
  settings_pinChanged: 'পিন বদলানো হয়েছে',
  settings_pinFailed: 'পিন বদলানো যায়নি।',
  settings_saveFailed: 'সেভ করা যায়নি।',
  settings_backup: 'ব্যাকআপ',
  settings_backupHelp:
    'পুরো খাতা একটা JSON ফাইলে নামায়: {n} এন্ট্রি সহ আইটেম, পার্টি ও অ্যাকাউন্ট।',
  settings_download: 'ব্যাকআপ ডাউনলোড',
  settings_device: 'এই ডিভাইস',
  settings_logout: 'লগ আউট',
  settings_language: 'ভাষা',
  settings_you: 'আপনি',
  settings_youTag: 'আপনি',
  settings_users: 'ইউজার',
  settings_addUser: '＋ ইউজার',

  sheet_newSale: 'নতুন বিক্রি',
  sheet_newPurchase: 'নতুন ক্রয়',
  sheet_walkIn: 'খুচরা কাস্টমার (নগদ)',
  sheet_cashPurchase: 'নগদ ক্রয় (সাপ্লায়ার নেই)',
  sheet_addItem: 'আইটেম যোগ করুন',
  sheet_searchItems: 'আইটেম খুঁজতে লিখুন…',
  sheet_noItemMatch: 'কোনো আইটেম মেলেনি। আগে স্টকে যোগ করুন।',
  sheet_left: 'আছে',
  sheet_qty: 'পরিমাণ',
  sheet_price: 'দাম',
  sheet_cost: 'ক্রয়মূল্য',
  sheet_remove: 'বাদ দিন',
  sheet_total: 'মোট',
  sheet_paidNow: 'এখন দিলো',
  sheet_inFull: 'পুরোটা',
  sheet_into: 'জমা হবে',
  sheet_from: 'থেকে',
  sheet_remaining: 'বাকি থাকলো',
  sheet_saveSale: 'বিক্রি সেভ করুন',
  sheet_savePurchase: 'ক্রয় সেভ করুন',
  sheet_saleSaved: 'বিক্রি #{no} সেভ হয়েছে · {total}',
  sheet_purchaseSaved: 'ক্রয় #{no} সেভ হয়েছে · {total}',
  sheet_addOne: 'অন্তত একটা আইটেম যোগ করুন।',

  sheet_editItem: 'আইটেম এডিট',
  sheet_newItem: 'নতুন আইটেম',
  item_name: 'নাম',
  item_namePlaceholder: 'যেমন: হেডলাইট বাল্ব H4',
  item_needsName: 'আইটেমের নাম দিন।',
  item_category: 'ক্যাটাগরি',
  item_categoryDefault: 'অন্যান্য',
  item_origin: 'উৎস',
  item_unit: 'একক',
  item_lowAlert: 'কম হলে সতর্ক',
  item_lowInvalid: 'সতর্কতার সীমা একটা পরিমাণ হতে হবে।',
  item_sellPrice: 'বিক্রয় মূল্য (৳)',
  item_sellInvalid: 'বিক্রয় মূল্য একটা টাকার অঙ্ক হতে হবে।',
  item_inStock: 'স্টকে আছে',
  item_avgCost: 'গড় ক্রয়মূল্য',
  item_adjust: 'স্টক ঠিক করুন',
  item_delete: 'আইটেম মুছুন',
  item_deleteHelp:
    'এই আইটেম কোনো এন্ট্রিতে থাকলে মোছার বদলে আর্কাইভ হবে, যাতে পুরনো বিক্রি ঠিক থাকে।',
  item_openingHead: 'শুরুর স্টক (ঐচ্ছিক)',
  item_buyPrice: 'ক্রয় মূল্য (৳)',
  item_buyRequired: 'শুরুর স্টকের ক্রয় মূল্য দিন।',
  item_asOf: 'তারিখ',
  item_saved: '{name} সেভ হয়েছে',
  item_added: '{name} যোগ হয়েছে',
  item_deleted: 'আইটেম মোছা হয়েছে',
  item_archived: '{name} আর্কাইভ হয়েছে (এন্ট্রি আছে, তাই ইতিহাসে থাকবে)',
  item_restore: 'আর্কাইভ করা আইটেম ফেরান',
  item_restored: 'আইটেম ফেরানো হয়েছে',

  sheet_editParty: 'পার্টি এডিট',
  sheet_newParty: 'নতুন পার্টি',
  party_needsName: 'পার্টির নাম দিন।',
  party_type: 'ধরন',
  party_phone: 'ফোন',
  party_address: 'ঠিকানা / নোট',
  party_openingHead: 'শুরুর ব্যালেন্স (ঐচ্ছিক)',
  party_whichWay: 'কোন দিকে',
  party_theyOwe: 'ওরা আপনাকে দেবে',
  party_youOweThem: 'আপনি ওদের দেবেন',
  party_advanceFrom: 'ওদের অগ্রিম জমা',
  party_advanceTo: 'ওদের অগ্রিম দেওয়া',
  party_saved: '{name} সেভ হয়েছে',
  party_added: '{name} যোগ হয়েছে',
  party_delete: 'পার্টি মুছুন',
  party_deleteHelp: 'এন্ট্রি থাকা পার্টি মোছে না, আর্কাইভ হয়।',
  party_deleted: 'পার্টি মোছা হয়েছে',
  party_archived: '{name} আর্কাইভ হয়েছে',

  sheet_receivePayment: 'টাকা নিন',
  sheet_payVendor: 'সাপ্লায়ারকে দিন',
  payment_choose: 'একটা পার্টি বেছে নিন।',
  payment_via: 'মাধ্যম',
  payment_notePlaceholder: 'চেক নং, বিকাশ…',
  payment_received: '{amount} পাওয়া গেছে',
  payment_paid: '{amount} দেওয়া হয়েছে',
  payment_dueSuffix: 'বাকি {amount}',
  payment_advanceSuffix: 'অগ্রিম {amount}',

  sheet_return: 'ফেরত লিখুন',
  return_type: 'ধরন',
  return_customerReturned: 'কাস্টমার ফেরত দিয়েছে',
  return_weReturn: 'সাপ্লায়ারকে ফেরত দিচ্ছি',
  return_walkIn: 'খুচরা (নগদ ফেরত দেওয়া)',
  return_noVendor: 'সাপ্লায়ার নেই (নগদ ফেরত পাওয়া)',
  return_item: 'আইটেম',
  return_chooseItem: 'একটা আইটেম বেছে নিন।',
  return_inStock: 'স্টকে',
  return_defectiveCount: 'নষ্ট',
  return_auto: 'স্বয়ংক্রিয় {amount}',
  return_autoFromPrice: 'দাম থেকে স্বয়ংক্রিয়',
  return_reason: 'কারণ',
  return_goesTo: 'যাবে',
  return_takeFrom: 'নেওয়া হবে',
  return_refundVia: 'ফেরতের মাধ্যম',
  return_refundViaIfCash: 'ফেরতের মাধ্যম (নগদ হলে)',
  return_help_saleDefective:
    'নষ্ট মালের বিনে যাবে, স্টকে ফিরবে না। টাকাটা কাস্টমারের হিসাবে জমা হবে (খুচরা হলে নগদ ফেরত)।',
  return_help_saleStock: 'স্টকে ফিরে যাবে। টাকাটা কাস্টমারের হিসাবে জমা হবে (খুচরা হলে নগদ ফেরত)।',
  return_help_purchaseDefective:
    'নষ্ট মালের বিন থেকে যাবে। টাকাটা সাপ্লায়ারের পাওনা থেকে কমবে (নয়তো নগদে ফিরবে)।',
  return_help_purchaseStock: 'স্টক কমবে। টাকাটা সাপ্লায়ারের পাওনা থেকে কমবে (নয়তো নগদে ফিরবে)।',
  return_recorded: 'ফেরত লেখা হয়েছে · {amount}',
  reason_defective: 'নষ্ট',
  reason_wrong_item: 'ভুল আইটেম',
  reason_not_needed: 'লাগবে না',
  reason_damaged: 'পথে ক্ষতিগ্রস্ত',

  sheet_expense: 'খরচ',
  sheet_drawing: 'মালিক / স্টাফের উত্তোলন',
  money_whatFor: 'কী বাবদ',
  money_who: 'কে',
  money_forPlaceholder: 'ভাড়া, বিদ্যুৎ, বেতন…',
  money_whoPlaceholder: 'মালিক, স্টাফের নাম…',
  money_whatForMissing: 'কী বাবদ খরচ?',
  money_whoMissing: 'কে নিচ্ছে?',
  money_owner: 'মালিক',
  money_expenseSaved: 'খরচ সেভ হয়েছে · {amount}',
  money_drawingSaved: 'উত্তোলন সেভ হয়েছে · {amount}',

  sheet_bankMovement: 'ব্যাংক লেনদেন',
  transfer_type: 'ধরন',
  transfer_deposit: 'নগদ → ব্যাংকে জমা',
  transfer_withdraw: 'ব্যাংক → নগদ তোলা',
  transfer_transfer: 'ব্যাংক → ব্যাংক ট্রান্সফার',
  transfer_cashAccount: 'নগদ অ্যাকাউন্ট',
  transfer_fromAccount: 'কোন অ্যাকাউন্ট থেকে',
  transfer_toAccount: 'কোন অ্যাকাউন্টে',
  transfer_noteRef: 'নোট / রেফারেন্স',
  transfer_noBank: 'এখনো কোনো ব্যাংক বা মোবাইল অ্যাকাউন্ট নেই। ব্যাংক স্ক্রিন থেকে যোগ করুন।',
  transfer_addFirst: 'আগে একটা ব্যাংক বা মোবাইল অ্যাকাউন্ট যোগ করুন।',
  transfer_saved: 'ব্যাংক লেনদেন সেভ হয়েছে',

  sheet_editAccount: 'অ্যাকাউন্ট এডিট',
  sheet_newAccount: 'নতুন অ্যাকাউন্ট',
  sheet_newUser: 'নতুন ইউজার',
  sheet_editUser: 'ইউজার এডিট',
  user_name: 'নাম',
  user_namePlaceholder: 'যেমন: রহিম',
  user_login: 'লগইন (ফোন বা ইমেইল)',
  user_loginPlaceholder: '01711-000000 বা name@example.com',
  user_pin: 'পিন (৪ থেকে ৮ সংখ্যা)',
  user_newPin: 'নতুন পিন',
  user_keepPin: 'না বদলালে খালি রাখুন',
  user_active: 'সক্রিয়',
  user_disabled: 'বন্ধ',
  user_help: 'প্রত্যেকে নিজের লগইন আর পিন দিয়ে ঢোকে; প্রতিটা এন্ট্রিতে থাকে কে লিখেছে।',
  user_needsName: 'নাম লাগবে।',
  user_needsPin: 'পিন ৪ থেকে ৮ সংখ্যার হতে হবে।',
  user_added: '{name} যোগ হয়েছে',
  user_saved: '{name} সেভ হয়েছে',
  account_namePlaceholder: 'যেমন: DBBL কারেন্ট, বিকাশ মার্চেন্ট',
  account_needsName: 'অ্যাকাউন্টের নাম দিন।',
  account_kind: 'ধরন',
  account_kindBank: 'ব্যাংক',
  account_kindMobile: 'মোবাইল ব্যাংকিং (বিকাশ, নগদ, রকেট…)',
  account_kindCash: 'ক্যাশ বাক্স',
  account_status: 'অবস্থা',
  account_open: 'চালু',
  account_closed: 'বন্ধ',
  account_opening: 'শুরুর ব্যালেন্স (৳)',
  account_saved: '{name} সেভ হয়েছে',
  account_added: '{name} যোগ হয়েছে',

  sheet_adjust: 'স্টক ঠিক করুন · {name}',
  adjust_now: 'এখন: স্টকে {qty} {unit}, গড় ক্রয়মূল্য {cost}',
  adjust_inBin: 'নষ্ট মালের বিনে',
  adjust_where: 'কোথায়',
  adjust_direction: 'কী করবেন',
  adjust_add: 'পিস যোগ',
  adjust_remove: 'পিস বাদ',
  adjust_unitCost: 'প্রতি এককের ক্রয়মূল্য (৳)',
  adjust_unitCostRequired: 'যোগ করা পিসের ক্রয়মূল্য দিন।',
  adjust_goesOutAt: 'বাদ যাবে',
  adjust_avgCost: 'গড় ক্রয়মূল্যে',
  adjust_reason: 'কারণ',
  adjust_saved: '{name} ঠিক করা হয়েছে',
  adjustReason_opening: 'শুরুর স্টক',
  adjustReason_count: 'গণনা সংশোধন',
  adjustReason_damage: 'নষ্ট বাদ',
  adjustReason_other: 'অন্যান্য',

  entry_notFound: 'পাওয়া যায়নি।',
  entry_by: 'লিখেছেন',
  entry_unknownUser: 'অজানা',
  entry_voidedBanner: 'বাতিল{when}। এটা আর কোথাও গণনা হয় না।',
  entry_on: ' {date} তারিখে',
  entry_void: 'এই এন্ট্রি বাতিল করুন',
  entry_voidHelp:
    'বাতিল করলে এই এন্ট্রি হুবহু উল্টে যায়, কিন্তু ইতিহাসে থাকে। স্টক, নগদ আর ব্যালেন্স আগের মতো ফিরে যায়।',
  entry_voidReason: 'কারণ (ঐচ্ছিক)',
  entry_voidReasonPlaceholder: 'যেমন: ভুল পরিমাণ',
  entry_confirmVoid: 'বাতিল নিশ্চিত করুন',
  entry_voiding: 'বাতিল হচ্ছে…',
  entry_keep: 'থাক',
  entry_voidedToast: '{title} বাতিল হয়েছে',
  entry_printMemo: 'মেমো প্রিন্ট',
  entry_total: 'মোট',
  entry_paid: 'পরিশোধ',
  entry_bokeya: 'বাকি',
  entry_stillOwed: 'এখনো দেনা',
  entry_amount: 'টাকা',
  entry_via: 'মাধ্যম',
  entry_kind: 'ধরন',
  entry_party: 'পার্টি',
  entry_item: 'আইটেম',
  entry_reason: 'কারণ',
  entry_wentTo: 'গেছে',
  entry_takenFrom: 'নেওয়া হয়েছে',
  entry_refundVia: 'ফেরতের মাধ্যম',
  entry_for: 'বাবদ',
  entry_who: 'কে',
  entry_from: 'থেকে',
  entry_to: 'যেখানে',
  entry_change: 'পরিবর্তন',
  entry_in: 'এ',
  entry_unitCost: 'একক ক্রয়মূল্য',
  entry_account: 'অ্যাকাউন্ট',
  entry_openingBalance: 'শুরুর ব্যালেন্স',
  entry_voidedEntry: 'বাতিল করা এন্ট্রি',
  entry_note: 'নোট',
  type_sale: 'বিক্রি',
  type_purchase: 'ক্রয়',
  type_payment: 'পেমেন্ট',
  type_return: 'ফেরত',
  type_expense: 'খরচ',
  type_drawing: 'উত্তোলন',
  type_transfer: 'ব্যাংক লেনদেন',
  type_stock_adjust: 'স্টক সংশোধন',
  type_account_opening: 'অ্যাকাউন্ট শুরু',
  type_party_opening: 'পার্টি শুরু',
  type_void: 'বাতিল',

  label_receivedFrom: 'পেয়েছেন:',
  label_paidTo: 'দিয়েছেন:',
  label_deposit: 'জমা → {to}',
  label_withdraw: '{from} থেকে তোলা',
  label_openingBalance: 'শুরুর ব্যালেন্স',
  label_deletedParty: '(মুছে ফেলা পার্টি)',
  label_deletedItem: '(মুছে ফেলা আইটেম)',
  label_closedAccount: '(বন্ধ অ্যাকাউন্ট)',
  label_perUnit: '/একক',

  memo_missing: 'এই মেমো নেই।',
  memo_back: '← ফিরে যান',
  memo_print: 'প্রিন্ট',
  memo_memo: 'মেমো',
  memo_customer: 'কাস্টমার:',
  memo_item: 'আইটেম',
  memo_qty: 'পরিমাণ',
  memo_price: 'দাম',
  memo_amount: 'টাকা',
  memo_total: 'মোট',
  memo_paid: 'পরিশোধ',
  memo_due: 'এই মেমোর বাকি',
  memo_previous: 'আগের ব্যালেন্স',
  memo_balanceNow: 'বর্তমান ব্যালেন্স',
  memo_note: 'নোট:',
  memo_thanks: 'ধন্যবাদ · বিক্রিত মাল দোকানের নিয়ম অনুযায়ী ফেরত নেওয়া হয়।',

  form_enterAmount: 'টাকার অঙ্ক দিন।',
  form_invalidAmount: 'সঠিক টাকার অঙ্ক দিন, যেমন ১২৫০ বা ৯৯.৫০।',
  form_negativeAmount: 'টাকা ঋণাত্মক হতে পারে না।',
  form_enterQty: 'পরিমাণ দিন।',
  form_invalidQty: 'সঠিক পরিমাণ দিন, যেমন ২ বা ১.৫।',
  form_offline: 'সংযোগ নেই। এন্ট্রি সেভ হয়নি।',
  form_failed: 'কিছু একটা সমস্যা হয়েছে। এন্ট্রি সেভ হয়নি।',

  err_must_be_fully_paid: 'খুচরা বিক্রিতে পুরো টাকা দিতে হয়। বাকি লিখতে একজন কাস্টমার বেছে নিন।',
  err_must_be_fully_paid_purchase:
    'নগদ ক্রয়ে পুরো টাকা দিতে হয়। দেনা লিখতে একজন সাপ্লায়ার বেছে নিন।',
  err_paid_exceeds_total: 'দেওয়া টাকা মোটের চেয়ে বেশি। বাড়তিটা পেমেন্ট হিসেবে লিখুন।',
  err_insufficient_stock: '{item} {where} মাত্র {availableText} {unit} আছে।',
  err_insufficient_stock_none: '{item} {where} কিছু নেই।',
  err_where_stock: 'স্টকে',
  err_where_defective: 'নষ্ট মালের বিনে',
  err_conflict: 'অন্য একটা ডিভাইস আগে সেভ করেছে। আবার চেষ্টা করুন।',
  err_void_blocked:
    'বাতিল করা যাচ্ছে না: এতে যোগ হওয়া {item} পরে বিক্রি, ফেরত বা সংশোধন হয়েছে। আগে পরের এন্ট্রিগুলো বাতিল করুন।',
  err_already_voided: 'এই এন্ট্রি আগেই বাতিল হয়েছে।',
  err_wrong_pin: 'ভুল পিন।',
  err_locked: 'অনেকবার ভুল পিন। এক মিনিট পরে চেষ্টা করুন।',
  err_same_account: 'দুটো আলাদা অ্যাকাউন্ট বেছে নিন।',
  err_duplicate_item: '{item} তালিকায় দুবার আছে।',
};
